import { render, staticRenderFns } from "./config.vue?vue&type=template&id=22bbb2da&scoped=true"
import script from "./config.vue?vue&type=script&lang=js"
export * from "./config.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22bbb2da",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\Developer\\Projects\\new-lottery-assistant-qd\\mer_plat_admin\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('22bbb2da')) {
      api.createRecord('22bbb2da', component.options)
    } else {
      api.reload('22bbb2da', component.options)
    }
    module.hot.accept("./config.vue?vue&type=template&id=22bbb2da&scoped=true", function () {
      api.rerender('22bbb2da', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/marketing/commission/config.vue"
export default component.exports